import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

export const Root = styled.div`
  padding: 11px 16px;
  height: 56px;
  width: 100%;
  background-color: ${uiToken.color.background.secondary};
  border-bottom: 1px solid ${uiToken.color.border.default};
  border-top: 1px solid ${uiToken.color.border.default};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Icon = styled.button`
  position: absolute;
  left: 8px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 4px;
  border-radius: 4px;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${uiToken.color.border.glassActive};
    outline-offset: 2px;
  }
`;
